
export const SETCITYS = 'setCitys'
export default {
  state: {
    cityData: {}
  },
  actions: {
    setCitys ({ commit }, value) {
      commit(SETCITYS, value)
    }
  },
  mutations: {
    [SETCITYS] (state, value) {
      state.cityData = value
    }
  },
  getters: {

  }
}



// WEBPACK FOOTER //
// ./src/js/store/common/citys.js